/**
 * 角色权限配置：定义每个角色可访问的路由路径
 */
export const roleMenuConfig: Record<string, string[]> = {
  founder: [
    '/', '/customers', '/payments', '/analytics', '/fund-monitor', '/ad-accounts', '/account-analysis', '/consumptions',
    '/opening-orders',
    '/media-todos',
    '/refunds', '/bm', '/policies', '/batch-import', '/users', '/approvals', '/receiving-accounts',
    '/audit-logs', '/staging', '/reconcile', '/card-spend-reconcile',
    '/port-account-dashboard',
    '/extension', '/extension/invite-assign', '/extension/pixel-share', '/extension/batch-rename',
    '/admin/kill-switch',
    '/card-platforms',
    // /slash/cards = Slash 全部卡片跨组搜索页 (M3-P1-4 2026-05-09); 同时也是详情路由 /slash/cards/:id 的访问 key
    '/slash/cards',
    '/slash/card-groups',
    // 2026-05-13: 卡返现费率管理 (founder-only 切换 Interlace ↔ Slash)
    '/cashback-rates',
    // 2026-05-14 PhotonPay 第二卡台 Wave 1.1: 凭证管理 founder-only
    '/photonpay/credentials',
    // 2026-05-15 PhotonPay Wave 1.2: 持卡人 Hub
    '/photonpay',
    // 2026-09-02 WasabiCard 第三卡台 阶段1: 凭证管理 founder-only
    '/wasabi/credentials',
    // 阶段3 批次2: 只读镜像 Hub。hasRouteAccess 是精确 includes 匹配而非前缀
    // 匹配, 所以 /wasabi 必须显式列出, 不会因为有 /wasabi/credentials 就通过
    '/wasabi',
  ],
  finance: [
    '/', '/customers','/payments', '/analytics', '/fund-monitor', '/ad-accounts', '/account-analysis', '/consumptions', '/refunds', '/policies',
    '/approvals', '/receiving-accounts', '/batch-import', '/staging', '/reconcile', '/card-spend-reconcile',
    '/port-account-dashboard',
    '/card-platforms',
    // 2026-05-08 Wave 7: 财务只读虚拟卡 (含预算组), 不开 BM 管理
    '/slash/cards', '/slash/card-groups',
    '/refunds',
    // 2026-05-15 PhotonPay Wave 1.2: 财务只读 (持卡人列表/详情)
    '/photonpay',
    // 2026-09-02 WasabiCard 阶段3: 财务只读镜像 (对账要看消费流水)。
    // 后端 RequireWasabiReader 同步放开, 且这些端点无写操作也不返回卡号
    '/wasabi',
  ],
  operator: [
    // 2026-07-10: 运营开客户管理面板, 写权限对齐财务/商务 (新增/删除/费率变更走双签审批, 后端 customers.py/policies.py 已加 OPERATOR)
    '/', '/customers', '/ad-accounts', '/account-analysis', '/consumptions',
    '/opening-orders',
    '/media-todos',
    '/extension', '/extension/invite-assign', '/extension/pixel-share', '/extension/batch-rename',
    '/audit-logs', '/batch-import', '/staging',
    '/card-platforms',
    // 2026-05-08 Wave 7: 运营与老板对齐, 拿到虚拟卡 + BM 管理
    '/slash/cards', '/slash/card-groups', '/bm',
    // 2026-05-15 PhotonPay Wave 1.2: 运营可读写持卡人
    '/photonpay','/policies',
    // 2026-09-02 WasabiCard 阶段3: 运营只读镜像 (排查卡状态)
    '/wasabi',
    // 2026-05-09: 后端已允许运营审批退款 (refunds.py:231) 与查看/编辑自己的审批单
    // (approvals.py:57); 前端补齐入口防止流转卡死
    '/refunds', '/approvals', '/card-spend-reconcile',
    // 2026-05-11: /receiving-accounts 收紧到 F+财 (M2 决策), 运营移除
  ],
  // 2026-07-14: 商务视图按需求收敛 — 首页/资金监控/消耗/账户分析/客户管理/收款/退款/政策,
  // 只看自己名下客户 (后端 apply_customer_ownership_filter 按 assigned_business_id 过滤);
  // 移除 /ad-accounts /approvals
  business: [
    '/', '/fund-monitor', '/consumptions',
    '/account-analysis', '/customers',
    '/payments', '/refunds',
    '/policies',
  ],
  assistant: ['/', '/customers', '/fund-monitor', '/media-todos', '/batch-import', '/policies', '/refunds', '/approvals'],
}

/**
 * 检查角色是否有权访问指定路由
 */
export function hasRouteAccess(role: string | null, path: string): boolean {
  if (!role) return false
  const allowed = roleMenuConfig[role]
  if (!allowed) return false
  return allowed.includes(path)
}
